export default __webpack_public_path__ + "static/media/COVID-19.17a7e709.jpg";